import React, { Suspense } from 'react';
import { Route } from 'react-router-dom';

import Loading from 'shared/ui/Loading';
import ClientGroups from 'features/parties/pages/client-groups/ClientGroups';
import Clients from 'features/parties/pages/Clients';
import SupplierGroups from 'features/parties/pages/supplier-groups/SupplierGroups';
import Suppliers from 'features/parties/pages/Suppliers';

export const partiesRoutes = (
  <Route path='parties'>
    <Route path='clients' element={<Clients />} />
    <Route path='client-groups' element={<ClientGroups />} />
    <Route path='suppliers' element={<Suspense fallback={<Loading />}><Suppliers /></Suspense>} />
    <Route path='supplier-groups' element={<SupplierGroups />} />
  </Route>
);

export const partiesTitles = [
  { path: '/parties/clients', title: 'Клиенты' },
  { path: '/parties/client-groups', title: 'Группы клиентов' },
  { path: '/parties/suppliers', title: 'Поставщики' },
  { path: '/parties/supplier-groups', title: 'Группы поставщиков' },
];
